// src/components/QuestionsTable.jsx
import React, { useEffect, useState, useMemo } from "react";
import Swal from "sweetalert2";
import DataTable from "react-data-table-component";
import { useSelector } from "react-redux";
import { selectAdminToken } from "../../sessionSlice";
import { selectTheme } from "../../themeSlice";
import { getAdminQustions } from "../../functions/getAdminQuestions";
import "./QuestionsTable.css";
import AddQuestionModal from "../addQuestion/addQuestion";
import QuizSettings from "../quizSettings/quizSettings";
import CsvUploadModal from "../uploadCSV/uploadCSV";
import { getQuestionsCSV } from "../../functions/getQuestionsCSV";
import OpenMedia from "../openMedia/openMedia";
import AiGenerateModal from "../aiGenerateModal/AiGenerateModal";
import { deleteQuestionById } from "../../functions/deleteQuestion";
import UploadIntro from "../uploadIntro/uploadIntro";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { deleteAllQuestions } from "../../functions/deleteQuestions";

const QuestionsTable = () => {
  const token = useSelector(selectAdminToken);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSettingModalOpen, setIsSettingModalOpen] = useState(false);
  const [isCSVModalOpen, setIsCSVModalOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const {
    currentTheme,
    user,
    data: themeData,
  } = useSelector((state) => state.theme);
  console.log("check user", user);
  const [rows, setRows] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [mediaUrl, setMediaUrl] = useState("");
  const [showMedia, setShowMedia] = useState(false);
  const [isAIModalOpen, setIsAIModalOpen] = useState(false);
  const [isIntroModelOpen, setisIntroModelOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  const navigate = useNavigate();

  const saveAndContineu = () => {
    navigate("/admin/quiz-settings");
  };

  function fixEncoding(value) {
    return value;
}



  useEffect(() => {
    async function fetchData() {
      if (themeData == null) return true;
      try {
        const response = await getAdminQustions({ currentTheme, token });
        console.log(response);
        const questions = response.questions || [];
        // const formatted = questions.map((q, i) => ({
        //   id: q.id, // Added ID for better row management
        //   no: i + 1,
        //   question: q.question_name,
        //   hint: q.question_hint || '-',
        //   correctAnswer:
        //     q.answer_id === 1 ? q.option_one :
        //     q.answer_id === 2 ? q.option_two :
        //     q.answer_id === 3 ? q.option_three :
        //     q.answer_id === 4 ? q.option_four : '',
        // }));
        const formatted = questions.map((q, i) => {
          const opt1 = fixEncoding(q.option_one || "");
          const opt2 = fixEncoding(q.option_two || "");
          const opt3 = fixEncoding(q.option_three || "");
          const opt4 = fixEncoding(q.option_four || "");

          return {
            id: q.id,
            no: i + 1,
            question: fixEncoding(q.question_name || ""),
            hint: q.question_hint || "-",
            // build correctAnswer from answer_id using fixed option strings
            correctAnswer:
              q.answer_id === 1
                ? opt1
                : q.answer_id === 2
                ? opt2
                : q.answer_id === 3
                ? opt3
                : q.answer_id === 4
                ? opt4
                : "",
            // keep original fields if you need them later (popup, task, images)
            raw: q, // optional: keep raw object for debugging / modals
          };
        });
        console.log(fixEncoding("\u00C2\u0092Hello\u00C2\u0092"));
        console.log("formatted",formatted);
        setRows(formatted);
        // Flip only actually runs during the quiz when the lifelines master
        // toggle is also on (see setUserQuestions.js on the backend: flip is
        // forced false there whenever lifelines is off), so a stale/leftover
        // flip=true from before lifelines was switched off shouldn't trigger
        // this warning either.
        if (formatted.length !== 0) {
          if (formatted.length < themeData.noOfQuestion) {
            Swal.fire(
              "Warning",
              `Number of questions to display (${themeData.noOfQuestion}) is more than the number of questions added (${formatted.length}). Add more questions or lower the count in Quiz Settings.`,
              "info"
            );
          } else if (themeData.lifelines && themeData.flip && formatted.length < themeData.noOfQuestion + 1) {
            Swal.fire(
              "Warning",
              "Flip lifeline requires 1 extra question. Currently your number of questions to display is equal to the total available questions.",
              "info"
            );
          }
        }
      } catch (error) {
        console.error("Error fetching questions:", error);
      }
    }

    if (currentTheme && token) fetchData();
  }, [currentTheme, token, themeData]);

  useEffect(() => {
    console.log(rows.length);
  }, []);

  const filteredItems = rows.filter(
    (item) =>
      (item.question &&
        item.question.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.hint &&
        item.hint.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.correctAnswer &&
        item.correctAnswer.toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <div className="search-container">
        <input
          type="text"
          placeholder="Search questions or answers"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          className="search-input"
        />
        <button
          type="button"
          onClick={handleClear}
          className="clear-search-btn"
        >
          Clear
        </button>
      </div>
    );
  }, [filterText, resetPaginationToggle]);

  const columns = [
    {
      name: "",
      selector: (row) => row.no,
      sortable: true,
      width: "80px",
      center: true,
    },
    {
      name: "Question",
      selector: (row) => row.question,
      sortable: true,
      wrap: true,
      minWidth: "250px",
    },
    {
      name: "Hint",
      selector: (row) => row.hint,
      cell: (row) => (
        <div className="hint-cell">
          {row.hint && row.hint !== "-" ? (
            <i
              class="fa-solid fa-pen"
              onClick={() =>
                handleOpen(`${process.env.REACT_APP_S3_PATH}${row.hint}`)
              }
            ></i>
          ) : (
            <span className="text-muted">-</span>
          )}
        </div>
      ),
      width: "150px",
    },
    {
      name: "Correct Answer",
      selector: (row) => row.correctAnswer,
      sortable: true,
      minWidth: "150px",
    },
{
  name: "Actions",
  cell: (row) => (
    <div className="action-buttons">
      <button className="delete-btn" onClick={() => deleteQuestion(row.id)}>
        <i className="fas fa-trash-alt"></i> Delete
      </button>
      <button className="edit-btn" onClick={() => onEditClick(row.id)}>
        <i className="fas fa-edit"></i> Edit
      </button>
    </div>
  ),
  ignoreRowClick: true,
  allowOverflow: true,
  width: "200px",
  fixed: "right",        // <- THIS makes it sticky natively
}
  ];

  async function deleteQuestion(id) {
    try {
      const response = await deleteQuestionById({ id, token });
      console.log(response);
      if (response.success) {
        window.location.reload();
      }
    } catch (error) {
      console.error("Error fetching questions:", error);
    }
  }

  const onAddClick = () => {
    setEditingId(null); // clear any edit
    setIsModalOpen(true);
  };

  const onEditClick = (qid) => {
    setEditingId(qid); // tell modal what to load
    setIsModalOpen(true);
  };

  const handleExport = async () => {
    try {
      // fetch the CSV as a Blob
      const csvBlob = await getQuestionsCSV({ currentTheme, token });

      // create a URL and trigger download
      const url = window.URL.createObjectURL(csvBlob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `questions_${currentTheme}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      Swal.fire("Error", err.message || "Could not download CSV", "error");
    }
  };

  async function deleteAllQuestionsTheme() {
    try {
      const response = await deleteAllQuestions({ currentTheme, token });
      console.log(response);
      if (response.success) {
        window.location.reload();
      }
    } catch (error) {
      console.error("Error fetching questions:", error);
    }
  }

  const deleteSelected = () => {
    if (selectedRows.length === 0) return;
    Swal.fire({
      title: "Are you sure?",
      text: `This will permanently delete ${selectedRows.length} selected question(s).`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (!result.isConfirmed) return;
      Promise.all(
        selectedRows.map((row) => deleteQuestionById({ id: row.id, token }))
      )
        .then(() => window.location.reload())
        .catch((error) => {
          console.error("Error deleting selected questions:", error);
          Swal.fire("Error", "Failed to delete one or more questions", "error");
        });
    });
  };

  const deleteAll = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will permanently delete all questions for this theme.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete all",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteAllQuestionsTheme();
      }
    });
  };

  const downloadSample = () => {
    const a = document.createElement("a");
    a.href =
      "https://2023-extramileplay-public.s3.ap-south-1.amazonaws.com/sample-csv.csv";
    a.download = "sample-csv.csv";
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  const handleOpen = (url) => {
    setMediaUrl(url);
    setShowMedia(true);
  };

  const handleClose = () => {
    setShowMedia(false);
    setMediaUrl("");
  };

  return (
    <>
      <AddQuestionModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        questionId={editingId}
      />

      <QuizSettings
        isOpen={isSettingModalOpen}
        onClose={() => setIsSettingModalOpen(false)}
      />

      <CsvUploadModal
        isOpen={isCSVModalOpen}
        onClose={() => setIsCSVModalOpen(false)}
      />

      <UploadIntro
        isOpen={isIntroModelOpen}
        onClose={() => setisIntroModelOpen(false)}
      />

      <AiGenerateModal
        isOpen={isAIModalOpen}
        onClose={() => setIsAIModalOpen(false)}
        currentTheme={currentTheme}
        token={token}
      />

      <div className="back-button-holder">
        <button
          className="back-button"
          onClick={() => navigate("/admin/rules")}
        >
          <i class="fa-solid fa-arrow-left"></i> Back
        </button>
      </div>
      <div className="table-header">
        {/* <h2>Questions</h2> */}
        {/* <div className="table-actions">
          <button className="btn outline" onClick={() => onAddClick()}>
              <i className="fas fa-plus-circle"></i> Add Question
            </button> 
            <button className="btn outline" onClick={() => handleExport()}>
              <i className="fas fa-file-export"></i> Export CSV
            </button>
            <button
              className="btn outline"
              onClick={() => setIsCSVModalOpen(true)}
            >
              <i className="fas fa-file-import"></i> Upload CSV
            </button>
            <button className="btn outline" onClick={downloadSample}>
              <i className="fas fa-file-download"></i> Sample CSV
            </button>
            <button
              className="btn outline"
              onClick={() => setIsSettingModalOpen(true)}
            >
              <i className="fas fa-gear"></i> Settings
            </button>
             <button
              className="btn outline"
              onClick={() => setisIntroModelOpen(true)}
            >
              <i className="fas fa-file"></i> Intro
            </button> 
            <button
            className="btn outline generate-with-ai"
            onClick={() => setIsAIModalOpen(true)}
          >
            <i className="fas fa-robot"></i> Generate with AI
          </button>
          </div> */}
      </div>

      <div className="question-page-blue-holder">
        <div className="blue-tabs-container">
          <div className="blue-tabs"></div>
          <div className="blue-tabs blue-tabs-active"></div>
          <div className="blue-tabs"></div>
        </div>
      </div>

      <div className="questions-table-container">
        <div className="question-header">
          <div className="question-header-title">Questions</div>
          <div className="question-header-action">
            <button
              className="add-new-question-v1"
              onClick={() => onAddClick()}
            >
              <i class="fa-solid fa-plus"></i> &nbsp; &nbsp; Add New Question
            </button>
            <button
              className="gear-button"
              onClick={() => setisIntroModelOpen(true)}
            >
              <i class="fa-solid fa-gear"></i>
            </button>
          </div>
        </div>
        <div className="question-header-button">
          <div className="question-header-left">
            <button
              className="btn outline"
              onClick={() => setIsCSVModalOpen(true)}
            >
              <i class="fa-solid fa-upload"></i> Upload Question CSV
            </button>
            <button className="btn outline" onClick={() => handleExport()}>
              <i class="fa-solid fa-download"></i> Export CSV
            </button>
          </div>
          <div>
            {selectedRows.length > 0 && (
              <button className="btn outline" onClick={() => deleteSelected()}>
                <i class="fa-solid fa-trash"></i> Delete Selected ({selectedRows.length})
              </button>
            )}
            <button className="btn outline" onClick={() => deleteAll()}>
              <i class="fa-solid fa-trash"></i> Delete All
            </button>
          </div>
        </div>
        <div>
          <button className="sample-csv" onClick={downloadSample}>
            Sample CSV
          </button>
        </div>
        <DataTable
          columns={columns}
          data={filteredItems}
          pagination
          paginationResetDefaultPage={resetPaginationToggle}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
          persistTableHead
          highlightOnHover
          responsive
          selectableRows
          onSelectedRowsChange={({ selectedRows }) => setSelectedRows(selectedRows)}
          noDataComponent={<div className="no-data">No questions found</div>}
        />
        <div className="rules-action-holder">
          <button className="save-and-continue" onClick={saveAndContineu}>
            Continue to Quiz Settings
          </button>
        </div>
      </div>
      {showMedia && <OpenMedia mediaUrl={mediaUrl} onClose={handleClose} />}
    </>
  );
};

export default QuestionsTable;
